import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import img1 from "../assets/images/img1.svg";
import img2 from "../assets/images/img2.svg";
import img3 from "../assets/images/img3.svg";

const slides = [
  {
    img: img1,
    heading: "Slide 1 Heading",
    subheading: "This is the subheading for slide 1",
  },
  {
    img: img2,
    heading: "Slide 2 Heading",
    subheading: "This is the subheading for slide 2",
  },
  {
    img: img3,
    heading: "Slide 3 Heading",
    subheading: "This is the subheading for slide 3",
  },
];

const ImageSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 500,
    arrows: false,
  };

  return (
    <div style={{ width: "100%", height: "99vh" }}>
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index}>
            <div
              style={{
                position: "relative",
                height: "100vh",
                backgroundImage: `url(${slide.img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#fff",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  bottom: "5%",
                  textAlign: "center",
                }}
              >
                <p style={{ fontSize: "1.2rem", margin: "10px 0" }}>
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Distinctio voluptatum totam quae animi laboriosam magni,
                  officia numquam <br /> inventore impedit exercitationem
                  laborum nam provident libero, rerum est, sunt doloremque
                </p>
              </div>

              <div
                style={{
                  position: "absolute",
                  top: "5%",
                  textAlign: "center",
                }}
              >
                <h1 className="text-3xl md:text-5xl lg:text-[55px] text-center py-[52px]">
                  {slide.heading}
                </h1>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageSlider;
